import React from 'react';
import styles from './index.module.scss';
import { CloseIcon } from 'src/components/shared/elements/icons/CloseIcon';

type Props = {
  onClick: () => void;
};

export const CloseButton: React.FC<Props> = ({ onClick }) => {
  return (
    <button
      className={styles.closeButtonContainer}
      onClick={onClick}
      data-testid="close-button"
      aria-label="close button"
    >
      <CloseIcon width={13} height={13} />
    </button>
  );
};
